import { useSyncExternalStore } from 'react';
import { loadDemoEmbedKey, subscribe } from './store';

/**
 * Reactive read of the embed_key design_system handed over. null until the
 * bootstrap resolves, so a pack page rendered first still picks the key up.
 */
export function useDemoEmbedKey(): string | null {
  return useSyncExternalStore(
    subscribe,
    loadDemoEmbedKey,
    () => null,
  );
}
